import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://register.educatory.ac/api';
// const API_URL = 'https://register.educatory.ac/api';

export const enrollStudent = async (data, isMultipart = false, isUpdate = false) => {

  const config = {
    headers: {
      'Content-Type': isMultipart ? 'multipart/form-data' : 'application/json'
    }
  };

  try {
    if (isUpdate) {
      const enrollmentId = data.get('enrollmentId'); // Extract enrollmentId from FormData
      const response = await axios.put(`${API_URL}/enrollments/${enrollmentId}`, data, config);
      return response.data;
    } else {
      const response = await axios.post(`${API_URL}/enrollments`, data, config);
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

export const verifyPayment = async (paymentData) => {
  try {
    const response = await axios.post(`${API_URL}/payments/verify`, paymentData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchEnrollmentByEmailOrId = async (userInput, courseId) => {
  try {
    const response = await axios.post(`${API_URL}/enrollments/fetch`, { userInput, courseId });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const validateReferralCode = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/referrals/validate`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const validateScholarshipCode = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/scholarships/validate`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyScholarshipOTP = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/scholarships/verify-otp`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendAmbassadorOTP = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/ambassadors/send-otp`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const registerAmbassador = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/ambassadors/register`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
